import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import {
  tablerArrowLeft,
  tablerBell,
  tablerMenu2,
  tablerPlus,
  tablerSearch,
  tablerUser,
  tablerUserCircle,
  tablerX,
  tablerDots,
  tablerBolt,
  tablerTool,
  tablerUsers,
} from '@ng-icons/tabler-icons';
import { ActionItemComponent } from './action-item.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'oc-card',
  standalone: true,
  imports: [CommonModule, NgIconComponent, ActionItemComponent, NgbDropdownModule],
  providers: [
    provideIcons({
      tablerSearch,
      tablerBell,
      tablerUserCircle,
      tablerMenu2,
      tablerArrowLeft,
      tablerX,
      tablerPlus,
      tablerUser,
      tablerDots,
      tablerTool,
      tablerBolt,
      tablerUsers,
    }),
  ],
  template: ` <div class="oc-card">
    <div class="oc-card-icon">
      <ng-icon [name]="icon" size="32" color="#222"></ng-icon>
    </div>
    <div class="oc-card-title">
      <div class="oc-card-maintitle">{{ mainTitle }}</div>
      <div class="oc-card-subtitle">{{ subTitle }}</div>
    </div>
    <div *ngIf="actions.length" ngbDropdown>
      <oc-action-item icon="tablerDots" ngbDropdownToggle></oc-action-item>
      <div ngbDropdownMenu>
        <button *ngFor="let action of actions" ngbDropdownItem (click)="action.action()">{{ action.title }}</button>
      </div>
    </div>
  </div>`,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
    }
    .oc-card {
      display: flex;
      flex: 1;
      padding: 1rem 0.8rem 1rem 1.2rem;
      gap: 0.85rem;
      align-items: center;
      background: white;
      border-radius: 0.65rem;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;

      .oc-card-icon {
        height: 30px;
      }

      .oc-card-title {
        overflow: hidden;
        flex: 1;
        line-height: 1.35;
      }

      .oc-card-maintitle {
        font-size: 1.2rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .oc-card-subtitle {
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #999;
      }

      .dropdown-toggle::after {
        display: none;
      }
    }
  `,
})
export class CardComponent {
  @Input() icon = '';
  @Input() mainTitle = '';
  @Input() subTitle = '';
  @Input() actions: any[] = [];
}
